const REPLACE = "replace";
const ADD = "add";
const REMOVE = "remove";
var Archtype;
(function (Archtype) {
    Archtype[Archtype["Object"] = 0] = "Object";
    Archtype[Archtype["Array"] = 1] = "Array";
    Archtype[Archtype["Map"] = 2] = "Map";
    Archtype[Archtype["Set"] = 3] = "Set";
})(Archtype || (Archtype = {}));
function getArchtype(thing) {
    return Array.isArray(thing)
        ? Archtype.Array
        : thing instanceof Map
            ? Archtype.Map
            : thing instanceof Set
                ? Archtype.Set
                : Archtype.Object;
}
function get(thing, prop) {
    return getArchtype(thing) === Archtype.Map ? thing.get(prop) : thing[prop];
}
// See https://github.com/immerjs/immer/blob/7a5382899bc8b0bf5e21972a1c7db63f53e1d697/src/utils/errors.ts
function die(errorCode, op, path) {
    throw new Error(`Immer error, code ${errorCode}. Op: ${op}, path: ${path.join(".")}`);
}
/**
 * This function was adapted from the one in
 * https://github.com/immerjs/immer/blob/7a5382899bc8b0bf5e21972a1c7db63f53e1d697/src/plugins/patches.ts
 * to mutate the state in place. The dependencies of the function were copied
 * into this file and also adapted in places.
 */
export function applyPatchesFast(state, patches) {
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    patches.forEach((patch) => {
        const { path, op } = patch;
        let base = state;
        for (let i = 0; i < path.length - 1; i++) {
            const parentType = getArchtype(base);
            const p = "" + path[i];
            // See #738, avoid prototype pollution
            if ((parentType === Archtype.Object || parentType === Archtype.Array) &&
                (p === "__proto__" || p === "constructor"))
                die(24, op, path);
            if (typeof base === "function" && p === "prototype")
                die(24, op, path);
            base = get(base, p);
            if (typeof base !== "object") {
                die(15, op, path);
            }
        }
        const type = getArchtype(base);
        // const value = deepClonePatchValue(patch.value); // used to clone patch to ensure original patch is not modified, see #411
        // const value = cloneDeep(patch.value); // used to clone patch to ensure original patch is not modified, see #411
        const value = patch.value;
        const key = path[path.length - 1];
        switch (op) {
            case REPLACE:
                switch (type) {
                    case Archtype.Map:
                        return base.set(key, value);
                    /* istanbul ignore next */
                    case Archtype.Set:
                        die(16, op, path);
                        return;
                    default:
                        // if value is an object, then it's assigned by reference
                        // in the following add or remove ops, the value field inside the patch will also be modifyed
                        // so we use value from the cloned patch
                        // @ts-ignore
                        return (base[key] = value);
                }
            case ADD:
                switch (type) {
                    case Archtype.Array:
                        return key === "-" ? base.push(value) : base.splice(key, 0, value);
                    case Archtype.Map:
                        return base.set(key, value);
                    case Archtype.Set:
                        return base.add(value);
                    default:
                        return (base[key] = value);
                }
            case REMOVE:
                switch (type) {
                    case Archtype.Array:
                        return base.splice(key, 1);
                    case Archtype.Map:
                        return base.delete(key);
                    case Archtype.Set:
                        return base.delete(patch.value);
                    default:
                        return delete base[key];
                }
            default:
                die(17, op, path);
        }
    });
    return state;
}
//# sourceMappingURL=applyPatchesFast.js.map